//페이지 AJAX
import { ajaxFrame } from '../../controller/assets/lib/ajaxForm';
//쿠키 호출
import { cookies } from '../../controller/assets/lib/cookies';
//제이쿼리 UI
import '../../lib/jquery.ui';
//라이브러리 호출
import * as echarts from 'echarts';
// import '../../lib/canvasjs.min';

//사이드 컨트롤러
export const asideController = {
    init: function() {
        this.sideLink();
    },
    asideToggleOnOff: function(el) {
        $(el).toggleClass('active');
        $('#container, #footer').toggleClass('asideOff');
    },
    sideLink: function(thisEl, linkType) {
        var $this = $(thisEl);
        var domain = location.hostname;
        var wonLink = '';
        var neoLink = '';
        if (domain != 'bid.emforce.co.kr') {
            wonLink = 'http://beta.wonderbox.emforce.co.kr/';
            neoLink = 'http://beta.neo.emforce.co.kr/';
        } else {
            wonLink = 'http://wonderbox.emforce.co.kr/';
            neoLink = 'http://neo.emforce.co.kr/';
        }
        $('.won_btn').attr('href', wonLink);
        $('.neo_btn').attr('href', neoLink);
    }
};
//상단 컨트롤러
const headerController = {
    init: function() {
        var param = window.location.hash;
        this.navigationAction(param);
        this.newsAction();
    },
    navigationAction: function(param) {
        $('#navigation').find('li').each(function(i) {
            var checkAttr = $(this).find('a').attr('href');
            if (param == checkAttr) {
                $('#navigation').find('li a').removeClass('active');
                $(this).find('a').addClass('active');
            } else if (param == '#/' || param == '#/index') {
                $('#navigation').find('li a').removeClass('active');
                $('#navigation').find('li:eq(0) a').addClass('active');
            }
        });
    },
    newsAction: function() {}
};

//btn click Event
var listCount = 50;
export const btnActions = {
    listMoreBtn: function(el, callName, count, moreClass) {
        listCount += count;
        if (callName == 'bidding') {
            biddingFunc.ListDataSetting(listCount, moreClass);
        }
    },
    logOutBtn: function() {
        loginFunc.memberLogOut();
    },
    newsDeleteBtn: function(el) {
        var number = $(el).attr('data-number');
        $(el).parents('li').remove();
        alwaysFunc.headerNewsDeleteData(number);
    },
    linkBtn: function(type) {},
    prevBtn: function() {},
    toggleBtn: function(type, el) {
        if (type == 'search') {
            $(el).stop().slideToggle();
            biddingFunc.biddingGroupSelectData();
        }
    },
    sortPop: function(thisEl, type, key) {
        var $this = $(thisEl);
        var $popEl = $('.all_view, .media_array');
        var media = $('.media');
        if ($this.next().hasClass('active') != true) {
            $popEl.removeClass('active').hide();
            $this.next().addClass('active').show();
        } else {
            $popEl.removeClass('active').hide();
        }
        if (type == 'filter') {
            favoriteFunc.favoriteFilterData(key);
        }
        $(document).keyup(function(e) {
            if (e.keyCode == 27) {
                $popEl.removeClass('active').hide();
            }
        });
    },
    textPop:function(thisEl) {
        var $this = $(thisEl);
        $this.parent().find('.rank_text_box').toggle();
        $(document).keyup(function(e) {
            if (e.keyCode == 27) {
                $this.parent().find('.rank_text_box').hide();
            }
        });
    }
};



//예약 도표 드래그기능
var dragColor = undefined;
var dragType = undefined;
var dragTypeArray = [];
var addCount = 0;
var colorObj = {};
var modifyColor = null;
export const dragChart = {
    init: function(typeData, device) {
        this.chartId = $('#drag-graph-box');
        this.gridBoxEl = this.chartId.find('.grid-box');
        var addList = this.chartId.find('.add-sch-list');
        this.chartId.show();

        this._handleEvent();
        this._conBox(addList, typeData, device);
    },
    _conBox: function(addList, typeData, device) {
        var typeKeys = Object.keys(typeData);
        var addBtn = $('#add-sch-btn');
        var closeBtn = $('#close-pop-btn');
        var okBtn = $('#add-ok-btn');
        var modifyBtn = $('#modify-ok-btn');
        var popEl = $('#drag-add-pop');
        var commentEl = $('.comment-text');
        var defaultColor = {};
        var eChangeColor = null;
        var typeCheck = false;
        addCount = 0;

        // 디폴트 컬러 자동 추가
        $('#type-color option').each(function() {
            var $this = $(this);
            var thisColor = $this.val();
            defaultColor[thisColor] = thisColor;
        });

        //목표순위 디바이스별 순위 맥스값 변경
        var goalOptions = function() {
            var maxLength = (device == 'mobile') ? 15:25;
            var $select = $('#goal-rank-input');
            var options = '';
            for(var i = 1; i <= maxLength; i++) {
                var val = (i < 10) ? '0' + i:i;
                options += "<option value='" + val + "'>" + i + "</option>";
            }
            $select.html(options);
        };

        goalOptions();

        //타입 생성 기능
        var colorType = function(nmVal, color, rankVal, maxVal, minVal, cpaVal, typeVal) {
            addCount++;
            var html = "<div class='add-type-btn type-" + color + "' data-type='" + typeVal + "' data-color='" + color + "' data-nm='" + nmVal + "' data-rank='" + rankVal + "' data-max='" + maxVal + "' data-min='" + minVal + "' data-cpa='" + cpaVal + "'><button type='button' onclick='dragChart._conBtnEvent(this);' class='add-type add-type-" + color + "' data-color='" + color + "'><span class='color-box'></span><span class='add-name'>" + nmVal + "</span></button><div class='hover-btn-area hide'><button type='button' data-color='" + color + "' class='type-btn-modify' onclick='dragChart._modifyBtn(this)'>수정</button><button type='button' class='type-btn-delete' onclick='dragChart._removeBtn(this);' data-color='" + color + "'>삭제</button></div></div>";

            commentEl.hide();
            addList.append(html);
        };

        //컬러 타입 수정
        var modifyColorType = function(nmVal, color, rankVal, maxVal, minVal, cpaVal, typeVal, modifyColor, $this) {
            if(confirm('예약을 변경하시겠습니까?') == true) {
                var elColor = $this.attr('data-color');
                var typeEl = $('.add-type-btn.type-' + elColor);
                var typeModifyBtn = typeEl.find('.type-btn-modify, #modify-ok-btn');
                var dataNames = ['type','color','nm','rank','max','min','cpa'];
                var dataArray = [typeVal,color,nmVal,rankVal,maxVal,minVal,cpaVal];
                //정보관련
                for(var i = 0; i < dataArray.length; i++) {
                    typeEl.attr('data-' + dataNames[i], dataArray[i]);
                    typeEl.find('.add-name').text(nmVal);
                }
                //컬러관련
                if(color != modifyColor) {
                    //타입 정보 변경
                    typeModifyBtn.attr('data-color', color);
                    $this.attr('data-color',color);
                    eChangeColor = color;
                    typeEl.find('.add-type').addClass('add-type-' + color).removeClass('add-type-' + elColor).attr('data-color', color);
                    typeEl.addClass('type-' + color).removeClass('type-' + elColor);
                    //변경 그리드 컬러 변환
                    $('.grid-box .box-grid').each(function() {
                        var $this = $(this);
                        var hasCheck = $this.hasClass('active-' + elColor);
                        if(hasCheck === true) {
                            $this.addClass('active-' + color).removeClass('active-' + elColor).attr('data-color', color);
                        }
                    });
                }
            }
        };
        //컬러 체크 OBJ
        var colorCheckFunc = function(callType, modifyColor) {
            $('.add-sch-list .add-type-btn').each(function(i) {
                var thisColor = $(this).attr('data-color');
                colorObj[thisColor] = thisColor;
            });
        };

        //타입 저장 기능
        var typesSave = function(callType, $this) {
            colorObj = {};
            var formId = $('#drag-add-form');
            var formVal = formId.serializeArray();
            typeCheck = $('.add-sch-list div').hasClass('add-type-btn');
            if(callType == 'modify') {
                var basicColor = $this.attr('data-color');
                if(eChangeColor == null) {
                        modifyColor = $this.attr('data-color');
                }else{
                    modifyColor = eChangeColor;
                }
            }
            var nmVal = formVal[0].value;
            var color = formVal[1].value;
            var typeVal = formVal[2].value;
            var maxVal = 0;
            var minVal = 0;
            var rankVal = 0;
            var cpaVal = 0;
            var forLoop = true;
            if(typeVal == 'Active') {
                rankVal = formVal[3].value;
                maxVal = formVal[4].value;
                minVal = formVal[5].value;
            }else{
                cpaVal = formVal[5].value;
                maxVal = formVal[6].value;
                minVal = formVal[7].value;
            }

            var saveData = [];
            var formCheck = false;

            //컬러 obj 추가
            colorCheckFunc(callType, modifyColor);


            //폼 유효성 체크
            formId.find('select, input').each(function(index) {
                var $this = $(this);
                var valueCheck = $this.val();
                var checkMessage = $this.attr('data-message');
                var validation = $this.attr('validation');
                if(validation == 'yes') {
                    var success = false;
                    var idCheck = $this.attr('id');
                    var setMax = Number($('#max-bid-input').val());
                    var setMin = Number($('#min-bid-input').val());

                    if(idCheck.indexOf('2') > -1) {
                        setMax = Number($('#max-bid-input-2').val());
                        setMin = Number($('#min-bid-input-2').val());
                    }
                    if(idCheck.indexOf('max') > -1 || idCheck.indexOf('min') > -1) {
                        //최대,최소입찰가 필터
                        if('' === setMax || '' === setMin) {
                            alert('최대입찰가,최소입찰가를 입력해 주세요.');
                            $this.focus();
                            formCheck = true;
                            return false;
                        }else if(0 < setMax && 0 < setMin) {
                            if(setMin < setMax) {
                                if((0 == setMax || 70 <= setMax) && (0 == setMin || 70 <= setMin)) {
                                    success = true;
                                }else{
                                    alert('최소입찰가,최대입찰가는 70원 미만으로 설정할 수 없습니다.');
                                    $this.focus();
                                    formCheck = true;
                                    return false;
                                }
                            }else{
                                alert('최대입찰가는 최소입찰가 동일하거나 미만으로 설정할 수 없습니다.');
                                $this.focus();
                                formCheck = true;
                                return false;
                            }
                        }else{
                            if((0 == setMax || 70 <= setMax) && (0 == setMin || 70 <= setMin)) {
                                success = true;
                            }else{
                                alert('최대입찰가,최소입찰가는 70원 미만으로 설정할 수 없습니다.');
                                $this.focus();
                                formCheck = true;
                                return false;
                            }
                        }
                    }else if(valueCheck == '' || valueCheck == undefined || valueCheck == null) {
                        alert(checkMessage);
                        $this.focus();
                        formCheck = true;
                        return false;
                    }
                }
            });
            if(formCheck == true) {
                return false;
            };

            //타입 유무 체크
            if(callType == 'save' && typeCheck == false) {
                addCount = 0;
            }else if(callType == 'modify') {
                delete colorObj[basicColor];
            }


            //타입 추가 필터 기능(저장,수정(save,modify))
            var colorArray = Object.keys(colorObj);
            var colorCount = 0;

            if ((addCount <= 4 && callType == 'save') || callType == 'modify') {
                if (colorArray.length == 0) {
                    if(callType == 'save') {
                        if(confirm('예약을 생성하시겠습니까?') == true) {
                            colorType(nmVal, color, rankVal, maxVal, minVal, cpaVal, typeVal, 'create');
                            colorObj[color] = color;
                        }else{
                            return;
                        }
                    }else{
                        alert('수정 할 수 있는 조건이 없습니다. 조건을 생성해주세요.');
                    }
                } else {
                    for (var i = 0; i <= colorArray.length; i++) {
                        if(callType == 'save') {
                            colorCount++;
                            if (colorArray[i] != color) {
                                if (colorArray.length == colorCount) {
                                    if(confirm('예약을 생성하시겠습니까?') == true) {
                                        typeCheck = true;
                                        colorObj[color] = color;
                                        colorType(nmVal, color, rankVal, maxVal, minVal, cpaVal, typeVal, 'create');
                                    }else{
                                        break;
                                    }
                                }
                            } else {
                                alert('다른 색상을 사용해주세요.');
                                break;
                            }
                        }else{
                            colorCount++;
                            if (colorArray[i] != color || colorArray[i] == modifyColor || modifyColor == color) {
                                if (colorArray.length == colorCount) {
                                    if(confirm('예약을 수정하시겠습니까?') == true) {
                                        typeCheck = true;
                                        delete colorObj[modifyColor];
                                        colorObj[color] = color;
                                        modifyColorType(nmVal, color, rankVal, maxVal, minVal, cpaVal, typeVal, modifyColor, $this);
                                    }else{
                                        break;
                                    }
                                }
                            } else {
                                alert('다른 색상을 사용해주세요.');
                                break;
                            }
                        }
                    }
                }
            }else{
                alert('더 이상 조건을 생성할 수 없습니다.');
            }


        };

        //타입 데이터 반영
        for(var i = 0; i < typeKeys.length; i++) {
            var color = typeKeys[i];
            var nmVal = typeData[color].nm;
            var typeVal = typeData[color].bid_status;
            var rankVal = typeData[color].goal_rank;
            var maxVal = typeData[color].max_bid_amt;
            var minVal = typeData[color].min_bid_amt;
            var cpaVal = typeData[color].goal_cpa;
            colorType(nmVal, color, rankVal, maxVal, minVal, cpaVal, typeVal);
        }


        //컨트롤 박스 이벤트
        addBtn.click(function(event) {
            var formId = $('#drag-add-form');
            var $rankForm = $('.rank-form-box');
            var $cpaForm = $('.cpa-form-box');

            $('#choice-1').prop('checked', true);
            $rankForm.show().find('input').attr('validation', 'yes');
            $cpaForm.hide().find('input').attr('validation', 'no');
            //폼 유효성 체크
            formId.find('input, select').each(function() {
                var $this = $(this);
                var type = $this.attr('type');

                if(type == 'number' || type == 'text') {
                    $this.val('0');
                }else{
                    $this.find('option:eq(0)').prop('selected', true);
                    $('#type-color').attr('class','').addClass('color-blue');
                }
            });
            popEl.show();
            okBtn.show();
            modifyBtn.hide();
            colorCheckFunc();
        });
        //설정 팝업 닫기
        closeBtn.click(function(event) {
            popEl.hide();
        });
        //설정 팝업 저장
        okBtn.click(function(event) {
            typesSave('save');
        });
        //설정 팝업 수정
        modifyBtn.click(function(event) {
            var $this = $(this);
            typesSave('modify', $this);
        });

    },
    //조건 클릭 버튼
    _conBtnEvent: function(thisEl) {
        var $this = $(thisEl);
        dragColor = $this.find('.color-box').css('background-color');
        dragType = $this.attr('data-color');
        $('.add-type').removeClass('on');
        $this.addClass('on');
    },
    //조건 수정 버튼
    _modifyBtn:function(thisEl) {
        var popEl = $('#drag-add-pop');
        var $this = $(thisEl);
        modifyColor = $this.attr('data-color');
        var parentsEl = '.add-type-btn';

        //데이터
        var dType = $this.parents(parentsEl).attr('data-type');
        var dColor = $this.parents(parentsEl).attr('data-color');
        var dNm = $this.parents(parentsEl).attr('data-nm');
        var dRank = $this.parents(parentsEl).attr('data-rank') - 1;
        var dMax = $this.parents(parentsEl).attr('data-max');
        var dMin = $this.parents(parentsEl).attr('data-min');
        var dCpa = $this.parents(parentsEl).attr('data-cpa');

        //엘리먼트
        var $nm = $('#nm-input');
        var $rank = $('#goal-rank-input');
        var $color = $('#type-color');
        var $max1 = $('#max-bid-input');
        var $min1 = $('#min-bid-input');
        var $cpa = $('#goal-cpa-input');
        var $max2 = $('#max-bid-input2');
        var $min2 = $('#min-bid-input2');
        var $rankForm = $('.rank-form-box');
        var $cpaForm = $('.cpa-form-box');

        //수정 버튼 액션
        popEl.show();
        $('#add-ok-btn').hide();
        $('#modify-ok-btn').show();
        $('#modify-ok-btn').attr('data-color', modifyColor);
        $nm.val(dNm);
        $color.find('.color-' + dColor).prop('selected', true);
        $color.attr('class', '').addClass('color-' + dColor);

        //타입체크 유효성 변환
        if(dType == 'Active') {
            $('#choice-1').prop('checked', true);
            $rank.find('option:eq(' + dRank + ')').prop('selected', true);
            $max1.val(dMax);
            $min1.val(dMin);
            $rankForm.show().find('input').attr('validation', 'yes');
            $cpaForm.hide().find('input').attr('validation', 'no');
        }else{
            $('#choice-2').prop('checked', true);
            $cpa.val(dCpa);
            $max2.val(dMax);
            $min2.val(dMin);
            $rankForm.hide().find('input').attr('validation', 'no');
            $cpaForm.show().find('input').attr('validation', 'yes');
        }


    },
    //조건 삭제 버튼
    _removeBtn: function(thisEl) {
        var $this = $(thisEl);
        var thisColor = $this.attr('data-color');
        var onCheck = $this.parent().prev().hasClass('on');
        if (confirm('설정된 예약 스케줄도 함께 삭제됩니다. 조건을 삭제하시겠습니까?') == true) {
            addCount--;
            delete colorObj[thisColor];
            //삭제값 초기화
            if (onCheck === true) {
                dragType = undefined;
            }
            if(addCount == 0) {
                $('.comment-text').show();
            }
            $this.parents('.add-type-btn').remove();
            $('.grid-box .box-grid').each(function() {
                var $this = $(this);
                var dataColor = $this.attr('data-color');
                var resetColors = dataColor.replace(thisColor,'');
                $this.removeClass('active-' + thisColor).attr('data-color',resetColors);
            });
        }
    },
    //설정 컬러 변경
    _boxColorChange: function(thisEl) {
        var $this = $(thisEl);
        var color = $this.val();
        $this.attr('class', '').addClass('color-' + color);
    },
    //설정 타입 변경
    _typeChange: function(thisEl) {
        var $this = $(thisEl);
        var typeCheck = $this.val();
        var $rankForm = $('.rank-form-box');
        var $cpaForm = $('.cpa-form-box');
        if (typeCheck == 'Active') {
            $rankForm.show().find('input').attr('validation', 'yes');
            $cpaForm.hide().find('input').attr('validation', 'no');
        } else {
            $rankForm.hide().find('input').attr('validation', 'no');
            $cpaForm.show().find('input').attr('validation', 'yes');
        }
    },
    //예약 스케줄 이벤트 핸들러
    _handleEvent: function() {
        var $gridBoxEl = this.gridBoxEl;

        $gridBoxEl
            .selectable()
            .on('selectablestop', function(event) {
                if (dragType != undefined) {
                    var selUi = $('.box-grid.ui-selected');
                    var selCheck = selUi.hasClass('active');
                    var colorCheck = [];
                    $('.add-sch-list .add-type-btn').each(function() {
                        var thisColor = $(this).find('.add-type').attr('data-color');
                        colorCheck.push(thisColor);
                    });
                    if (selCheck === true) {
                        for (var i = 0; i <= colorCheck.length; i++) {
                            selUi.removeClass('active-' + colorCheck[i]).attr('data-color', '');
                        }
                    }
                    selUi.addClass('active active-' + dragType).attr('data-color', dragType);

                } else {
                    alert('조건을 선택하세요.');
                    event.preventDefault();
                }
            });
    }
}


//chart Controller
export const chartUi = {
    init: function(data, type) {
        var chartData = data;
        var target = data.target;
        var settingData = chartUi._set(chartData, type, target);
        var ctx = document.getElementById("chartContainer");
        this.chart = echarts.init(ctx);
        var charts = this.chart;
        charts.setOption(settingData, true);
    },
    _set: function(data, type, target) {
        var seDatas = [];
        var chartData = data.chart_data;
        var dataTitle = Object.keys(chartData).sort();

        if(type == 'chart1') {
            var trueData = data.true_sites;
            var select = {};
            var x = {};
            var y = [0];
            var yLength = 15;
            if(target != 'mobile') {
                yLength = 25;
            }
            for(var i = yLength; i > 0; i--) {
                y.push(i);
            }
            var dateOne = null;
            var rankOne = null;
            var lengCut = 25;
            for(var idx=0; idx<dataTitle.length; idx++){
                dateOne = chartData[dataTitle[idx]];
                for(var key in dateOne){
                    rankOne = dateOne[key];
                    rankOne.site = rankOne.site.substring(0, lengCut);
                    if( !x.hasOwnProperty( rankOne.site ) ){
                        x[rankOne.site] = new Array();
                        x[rankOne.site].length = idx;
                    }
                    x[rankOne.site].push( rankOne.rank );
                }

                for(var xKey in x){
                    x[xKey].length = (idx+1);
                }
            }


            var nameKey = Object.keys(x);
            var maxLength = nameKey.length;
            var startLength = 0;
            for (var i = 0; i < maxLength; i++) {
                for (var i2 = 0; i2 < x[nameKey[i]].length; i2++) {
                    var dataRank = x[nameKey[i]][i2];
                    if(dataRank == undefined) {
                        x[nameKey[i]][i2] = 0;
                    }
                }

                var seData = {
                    name:nameKey[i],
                    type:'line',
                    data:x[nameKey[i]]
                }

                startLength = x[nameKey[i]].length;
                seDatas.push(seData);
            }
            var perInt = function(length) {
                var returnPer = 100 - Math.round((length/startLength) * 100);
                return returnPer;
            };
            //option
            var zoomStart = perInt(6);
            var zoomEnd = 100;
            var boundary = false;


            for(var idx = 0; idx < nameKey.length; idx++) {
                select[nameKey[idx]] = false;
            }
            for(var i = 0; i < trueData.length; i++) {
                select[trueData[i]] = true;
            }

            var legendSet = {
                type:'scroll',
                orient:'vertical',
                data:nameKey,
                width:200,
                height:292,
                itemGap:10,
                padding:[
                    0,  // up
                    0, // right
                    10,  // down
                    0, // left
                ],
                textStyle:{
                    fontSize:13,
                },
                z:1,
                top:35,
                left:0,
                selected: select
            };
            var yAxisSet = {
                type: 'category',
                data:y
            };
        }else{
            var nameKey = data.kwd_nm;
            //option
            var zoomStart = 0;
            var zoomEnd = 100;
            var boundary = [0, '100%'];
            var legendSet = {
                data:[nameKey],
                width:200,
                height:300,
                padding:5,
                top:30,
                left:0
            };
            var yAxisSet = {
                type: 'value',
                data:y
            };



            var x = [];
            for (var i = 0; i < dataTitle.length; i++) {
                x.push(chartData[dataTitle[i]]);
            }

            var y = x;

            var seData = {
                name:nameKey,
                type:'line',
                data:x
            };
            seDatas.push(seData);
        }


        var setting = {
            tooltip: {
                trigger: 'axis'
            },
            dataZoom: [
                {
                    show: true,
                    realtime: true,
                    start: zoomStart,
                    end: zoomEnd
                },
                {
                    type: 'inside',
                    realtime: true,
                    start: zoomStart,
                    end: zoomEnd
                }
            ],
            toolbox: {
                show: true,
                right: '7%',
                top: '0',
                feature: {
                    mark: {
                        show: false,
                        title: {
                            mark: 'mark',
                            markUndo: 'markUndo',
                            markClear: 'markClear'
                        },
                        lineStyle: {
                            width: 2,
                            color: '#1e90ff',
                            type: 'dashed'
                        }
                    },
                    dataZoom: {
                        yAxisIndex: 'none',
                        show: true,
                        title : {
                            zoom : '영역확대',
                            back : '뒤로가기'
                        }
                    },
                    magicType: {
                        show: true,
                        title: {
                            line: '라인',
                            bar: '그래프',
                            stack: 'stack',
                            tiled: 'tiled',
                            force: 'force',
                            chord: 'chord',
                            pie: '파이',
                            funnel: 'funnel'
                        }
                    },
                    restore: {
                        show: true,
                        title: '업데이트'
                    },
                    saveAsImage: {
                        show: false,
                        title: '이미지저장'
                    }
                }
            },
            grid: {
                left: 220,
                right: '8%',
                top:30,
                bottom: '13%',
                containLabel: true
            },
            legend: legendSet,
            xAxis: {
                type: 'category',
                boundaryGap: boundary,
                data: dataTitle
            },
            yAxis: yAxisSet,
            series: seDatas
        };
        return setting;
    },
    _resetZoom: function() {
        this.chart.resetZoom();
    }
}




//PopUp Event
export const layerPopup = {
    init: function() {
        this.toggle();
    },
    open: function(thisEl, elId) {
        var elThis = '#' + elId;
        var $this = $(thisEl);
        var $listEl = $('#bid-list-body-1');
        var $listEl2 = $('#bid-list-body-2');
        var type = $this.attr('data-name');
        var callBackFunc = null;
        var autoKey = false;
        var manualKey = false;
        var allPopChecked = function() {
            var thisType = $(thisEl).attr('data-type');
            var thisKey = $(thisEl).attr('data-key');
            if (thisType == 'single') {
                $('#bid-list-body tr').find("input[type='checkbox']").prop('checked', false);
                $('.' + thisKey).find("input[type='checkbox']").prop('checked', true);
            }
        };
        //공용 팝업
        var popUpType = ['/popup/condition.html', '/popup/addKeyword.html', '/popup/moveKeyword.html', '/popup/manualBid.html', '/popup/addFavorite.html', '/popup/history.html', '/popup/advSetting.html', '/popup/layerPopupData.html'];

        //일괄설정용 팝업(즐겨찾기)
        var favoritePop = ['/popup/setPopRank.html', '/popup/setPopCpa.html', '/popup/setPopTarget.html', '/popup/setPopBooking.html', '/popup/setPopRate.html'];
        //단독 팝업(즐겨찾기)
        var favoritePop2 = ['/popup/booking.html', '/popup/chart.html', '/popup/target.html','/popup/rate.html','/popup/rate_cpa.html'];

        var onCheck = $this.find('>input').prop('checked');
        //자동입찰,수동입찰 체크
        $listEl.find("tr input[type='checkbox']").each(function() {
            var $this = $(this);
            var key = $this.attr('data-id');
            var bidStatusCheck = $this.find('.bidStatus-td > p').attr('data-status');
            var check = $this.prop('checked');
            if(check == true) {
                if(bidStatusCheck != 'Inactive') {
                    autoKey = true;
                }else{
                    manualKey = true;
                }
            }
        });

        if (onCheck == false || onCheck == undefined) {
            $('.layer-pop, .fixed-pop').remove();
            //전 페이지 공용
            if (type == 'createCondition') {
                var thisData = $this.data("id");
                var thisListId = $('.' + thisData).attr('data-id');
                ajaxFrame.ajaxAppendCall(elThis, 'GET', popUpType[0], 'html', true);
                createFunc.createConditionPopUpDate(thisListId);
            } else if (type == 'keywordsInsertBidFavorite') {
                ajaxFrame.ajaxAppendCall('#wrap', 'GET', popUpType[4], 'html', true, biddingFunc.openBidFavoritePopUp);
            } else if (type == 'bidChange') {
                ajaxFrame.ajaxAppendCall('#wrap', 'GET', popUpType[3], 'html', true, biddingFunc.openBidAmtPopup);
            } else if (type == "history") {
                var dataKey = $(thisEl).data("key");
                ajaxFrame.ajaxAppendCall('#wrap', 'GET', popUpType[5], 'html', true, favoriteFunc.favoriteHistoryPop, dataKey);
            } else if (type == 'advSetting') {
                ajaxFrame.ajaxAppendCall('#wrap', 'GET', popUpType[6], 'html', true, alwaysFunc.advSettingPop);
            }

            //즐겨찾기 수동입찰 팝업
            else if (type == "bidFavorite") {
                ajaxFrame.ajaxAppendCall('#wrap', 'GET', popUpType[3], 'html', true, favoriteFunc.favoriteBidAllChangePopUp);
            }
            //즐겨찾기 키워드 추가,이동 팝업
            else if (type == "MoveFavorite") {
                ajaxFrame.ajaxAppendCall('#wrap', 'GET', popUpType[2], 'html', true, favoriteFunc.favoriteKeywordMovePop);
            } else if (type == "favoriteKeyword") {
                ajaxFrame.ajaxAppendCall('#wrap', 'GET', popUpType[1], 'html', true, favoriteFunc.favoriteKeywordPopUp);
            }

            //즐겨찾기 일괄설정 팝업
            else if (type == 'setPop-1') {
                allPopChecked();
                ajaxFrame.ajaxAppendCall('#wrap', 'GET', favoritePop[0], 'html', true, favoriteFunc.favoriteBidSetPopCallBack1);
            } else if (type == 'setPop-2') {
                allPopChecked();
                ajaxFrame.ajaxAppendCall('#wrap', 'GET', favoritePop[1], 'html', true, favoriteFunc.favoriteBidSetPopCallBack2);
            } else if (type == 'setPop-3') {
                allPopChecked();
                ajaxFrame.ajaxAppendCall('#wrap', 'GET', favoritePop[2], 'html', true, favoriteFunc.favoriteBidSetPopCallBack3);
            } else if (type == 'setPop-5') {
                allPopChecked();
                ajaxFrame.ajaxAppendCall('#wrap', 'GET', favoritePop[3], 'html', true, favoriteFunc.favoriteScheDuleData, 'multi');
            } else if (type == 'setPop-6') {
                allPopChecked();
                ajaxFrame.ajaxAppendCall('#wrap', 'GET', favoritePop[4], 'html', true, favoriteFunc.favoriteBidSetPopCallBack6);
            }

            //즐겨 찾기 예약, 타겟설정, 그래프 팝업
            else if (type == 'booking') {
                var keywordKey = $this.parents('tr').data("id");
                ajaxFrame.ajaxAppendCall('#wrap', 'GET', favoritePop2[0], 'html', true, favoriteFunc.favoriteScheDuleData, keywordKey);
            } else if (type == 'chart1' || type == 'chart2' || type == 'chart3') {
                var keywordKey = $this.data("key");
                var types = [type,keywordKey];
                ajaxFrame.ajaxAppendCall('#wrap', 'GET', favoritePop2[1], 'html', true, favoriteFunc.favoriteChartData, types);
            } else if (type == 'target') {
                var thisKey = $(thisEl).parents('tr').attr('data-id');
                ajaxFrame.ajaxAppendCall('#wrap', 'GET', favoritePop2[2], 'html', true, favoriteFunc.favoriteTargetCallBack, thisKey);
            } else if (type == 'rate') {
                var thisKey = $(thisEl).parents('tr').attr('data-id');
                ajaxFrame.ajaxAppendCall('#wrap', 'GET', favoritePop2[3], 'html', true, favoriteFunc.favoriteRateData, thisKey);
            } else if (type == 'rateCpa') {
                var thisKey = $(thisEl).parents('tr').attr('data-id');
                ajaxFrame.ajaxAppendCall('#wrap', 'GET', favoritePop2[4], 'html', true, favoriteFunc.favoriteRateCpaData, thisKey);
            }


        } else {
            return;
        }


        setTimeout(function() {
            $(".fixed-pop > div, .pop_type01").draggable({
                handle: $(".popup-title")
            });
            $("#drag-add-pop").draggable({
                handle: $("#drag-add-pop h4")
            });
            $(document).keyup(function(e) {
                if (e.keyCode == 27) {
                    layerPopup.close();
                }
            });
        }, 500);
    },
    close: function() {
        $('.layer-pop, .fixed-pop').fadeOut(200);
        setTimeout(function() {
            $('.layer-pop, .fixed-pop').remove();
        }, 200);
    },
    toggle: function(el, thisEl) {
        $(el).toggle();
        $(thisEl).toggleClass('active');
        if (el == '.news-popup') {
            $(thisEl).find('.member-icon').toggleClass('active');
            $(thisEl).find('.member-icon').attr('src', '/image/common/notice_icon_on.png');
        }
    }
};

//로그인 로그아웃 교체
export const loginCheck = {
    init: function() {
        this.loginOnOff();
    },
    loginOnOff: function() {
        var userCheck = cookies.getCookies('user_id');
        if (userCheck != null) {
            $('.user-nomember').remove();
        } else {
            $('.user-member').remove();
        }
    }
};

export const tabAction = {
    init: function() {

    },
    tabChange: function(contents, btnEl) {
        var contentsEl = $('#' + contents);
        $('.tab-contents, .tab_btn_wrap button').removeClass('active');
        $(btnEl).addClass('active');
        $(contentsEl).addClass('active');
    }
};

export const listCheckAction = {
    init: function() {},
    allCheck: function() {
        var allCheckProp = $('.list-all-check').prop('checked');
        $('.table-list-body').find('tr').each(function() {
            var hideCheck = $(this).hasClass('hide');
            var checkProp = $('.list-check').prop('checked');
            if (allCheckProp == true) {
                if(hideCheck == false) {
                    $(this).find('.list-check').prop('checked', true);
                }
            } else {
                $(this).find('.list-check').prop('checked', false);
            }
            favoriteFunc.favoriteBtnOnOffEvent();
        });
    }
}

//WINDOW CALL
window.headerController = headerController;
window.asideController = asideController;
window.btnActions = btnActions;
window.layerPopup = layerPopup;
window.loginCheck = loginCheck;
window.listCheckAction = listCheckAction;
window.tabAction = tabAction;
window.dragChart = dragChart;
window.chartUi = chartUi;

export function baseActions() {
    asideController.init();
    headerController.init();
    layerPopup.init();
    listCheckAction.init();
    alwaysFunc.init();
    loginCheck.init();
}



// WEBPACK FOOTER //
// ./js/actions/ui/uiAction.js